import React, {useState, useEffect} from 'react';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import PropTypes from 'prop-types';
import { longButtonStyle, wizzardBarStyle } from './theme';

export default function ProgramSelectorComp({pageState, isAdmin, isReports, isAssignments}) {

    return (
        <div style={{paddingTop:'20px'}}>
        {isReports &&<Row style={wizzardBarStyle}> <h5>  &nbsp; {isAdmin?2:1}) Select a Report Group </h5></Row>}
        {isAssignments && <Row style={wizzardBarStyle}> <h5>  &nbsp; {isAdmin?2:1}) Select an Assignment Group </h5></Row>}
        <br/>
            <Row>        
                {isReports && <Col xs={3}><CategButton pageState={pageState} category="Student Marks" displayName="Student Marks" unselectedColor="info"/></Col>}
                {isAssignments && <Col xs={3}><CategButton pageState={pageState} category="Student Assignments" displayName="Student Assignments" unselectedColor="info"/></Col>}
                <Col xs={3}><CategButton pageState={pageState} category="(K-3) Reading Programs" displayName="K-3 Reading" unselectedColor="info"/></Col>
                <Col xs={3}><CategButton pageState={pageState} category="(K-3) Math Programs" displayName="K-3 Math" unselectedColor="info"/></Col>                
                <Col xs={3}><CategButton pageState={pageState} category="ESL Programs" displayName="ELL (English Learning)" unselectedColor="info"/></Col>
            </Row> 
            <Row> 
                {isReports && <Col xs={3}><CategButton pageState={pageState} category="Recently Used Programs" displayName="Recently Used" unselectedColor="info"/></Col>}
                {isAssignments && <Col xs={3}><CategButton pageState={pageState} category="Assigned Programs" displayName="Currently Assigned" unselectedColor="info"/></Col>}
                <Col xs={3}><CategButton pageState={pageState} category="(4-6) Reading Programs" displayName="4-6 Reading" unselectedColor="info"/></Col>
                <Col xs={3}><CategButton pageState={pageState} category="(4-6) Math Programs" displayName="4-6 Math" unselectedColor="info"/></Col>                
                <Col xs={3}><CategButton pageState={pageState} category="Science and Geography Programs" displayName="Science/Geography" unselectedColor="info"/></Col>
            </Row> 
            <Row> 
                <Col xs={3}><CategButton pageState={pageState} category="Favorite Programs" displayName="Favorites" unselectedColor="info"/></Col>   
                <Col xs={3}><CategButton pageState={pageState} category="Reader Programs" displayName="High-Low & Early Readers" unselectedColor="info"/></Col>
                <Col xs={3}><CategButton pageState={pageState} category="Mad Minute" displayName="Math Facts" unselectedColor="info"/></Col>                
                <Col xs={3}><CategButton pageState={pageState} category="User Programs" displayName="⭐&nbsp;Spelling Lists" unselectedColor="info"/></Col>
            </Row>
        </div>
    );
}

ProgramSelectorComp.propTypes = {
    isReports: PropTypes.string,
    isAssignments: PropTypes.string
  };

const CategButton = ({displayName, category, pageState, unselectedColor}) => {
    const [disableButton, setDisableButton] = useState(true);
    useEffect(()=>{
        let disabled = true;
        if(pageState.categsData[category] && pageState.categsData[category].length>0)
            disabled = false;
        setDisableButton(disabled);
    });
    const clickHandler = (groupID) => {
        pageState.setCurrentCateg(groupID);
    };
    return(
        <Button onClick={()=>clickHandler(category)} style={longButtonStyle} variant={(pageState.currentCateg===category)?'primary':unselectedColor} disabled={disableButton}> {displayName} </Button>
    );
};